import React from 'react';
import { Link } from 'react-router-dom';

import { getClickAttrs } from '../../Analytics/gtag';
import { clickCategories, clickLocations } from '../../../utils/analytics';
import { navigationIDs } from '../../Analytics/testIDConfig';
import TrackedClick from '../../Analytics/TrackedClick';
import Img from '../../Img';

import styles from '../header.scss';

const MobileIconButton = ({ label, navId, to, selected, iconUnselected, iconSelected, notificationDot }) => {
    return (
        <TrackedClick
            eventName="Header CTA Clicked"
            label={label}
            traits={{
                container: 'Mobile Navbar',
                uxType: 'link',
                content: label,
            }}
        >
            <Link
                className={styles.navIconLink}
                to={to}
                {...getClickAttrs({
                    category: clickCategories.HEADER,
                    context: label,
                    location: clickLocations.HEADER_CTA,
                    testid: `${navigationIDs[navId].component}-${navigationIDs[navId].location}-${navigationIDs[navId].id}`,
                })}
            >
                <Img alt={`${label} icon`} src={selected ? iconSelected : iconUnselected} />
                <div className={`title ${selected ? 'text-bold' : ''}`} data-testid={`header.mobile-nav.${navId}.label`}>
                    {label}
                </div>
                {notificationDot
                    ? <div className="notification-dot" /> : null}
            </Link>
        </TrackedClick>
    );
};

export default MobileIconButton;
